module.exports = __webpack_public_path__ + "media/img/pages/profile/aldi ger 1-1e3721dc5aeee73c53f2c367532fe30c.jpg";